/**
 * Floating legend showing regulation status color key + color-overlay toggle.
 */
import { STATUS_CONFIG } from '../types';
import type mapboxgl from 'mapbox-gl';

/** Module-level state so addLayers() can restore visibility after style switches */
let colorOverlayActive = true;

/** Read the current color-overlay state (used by main.ts on every style.load) */
export function isColorOverlayActive(): boolean {
  return colorOverlayActive;
}

export function initLegend() {
  const legend = document.getElementById('legend')!;

  const items = Object.entries(STATUS_CONFIG).map(([_, config]) => `
    <div class="legend-item">
      <span class="legend-color" style="background:${config.color}"></span>
      <span>${config.label}</span>
    </div>
  `).join('');

  // Toggle button lives inside the legend card, below the colour key
  legend.innerHTML = `
    <div class="legend-title">Ease of Flight</div>
    <div class="legend-items">${items}</div>
    <div class="legend-divider"></div>
    <button id="color-overlay-toggle" class="color-overlay-toggle active" title="Toggle regulation color overlays">
      <span class="color-overlay-icon">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="13" height="13">
          <circle cx="12" cy="12" r="10"/>
          <path d="M12 2a10 10 0 0 1 0 20"/>
          <path d="M2 12h20"/>
        </svg>
      </span>
      <span class="color-overlay-label">Turn Off Color Overlays</span>
    </button>
    <a
      href="/about.html"
      class="legend-about-link"
      title="How Ease of Flight ratings are decided"
      style="display:block;margin-top:6px;font-size:10px;color:var(--color-text-dim);text-decoration:none;letter-spacing:0.2px;transition:color var(--transition-normal);"
      onmouseover="this.style.color='var(--color-text-secondary)'"
      onmouseout="this.style.color='var(--color-text-dim)'"
    >About these ratings</a>
  `;
}

/**
 * Wire the color-overlay toggle to show/hide choropleth layers.
 * Call once after the map and layers are ready.
 */
export function wireColorOverlayToggle(map: mapboxgl.Map) {
  const btn = document.getElementById('color-overlay-toggle') as HTMLButtonElement | null;
  if (!btn) return;

  btn.addEventListener('click', () => {
    colorOverlayActive = !colorOverlayActive;
    btn.classList.toggle('active', colorOverlayActive);
    btn.querySelector<HTMLSpanElement>('.color-overlay-label')!.textContent =
      colorOverlayActive ? 'Turn Off Color Overlays' : 'Turn On Color Overlays';

    const vis = colorOverlayActive ? 'visible' : 'none';
    if (map.getLayer('country-fills'))  map.setLayoutProperty('country-fills',  'visibility', vis);
    if (map.getLayer('country-borders')) map.setLayoutProperty('country-borders', 'visibility', vis);
  });
}
